import {Component} from '@angular/core';

@Component({
    selector: 'qa-signup',
    templateUrl: './signup.component.html',
    styleUrls: ['./signup.component.scss'],
    standalone: false
})
export class SignupComponent {
  constructor() { }
}
